<template>
	<div class="content-padding social-share-block margin-module" v-if="currentPage">
		<div class="container container--small">
			<h4 class="socialt-titler">
				Share
				<template v-if="currentPage.type === 'events'">event</template>
				<template v-if="currentPage.type === 'post'">article</template>
			</h4>
			<SocilaSharing :url="fixLink()" :title="currentPage.title" :description="pageExcerpt()" inline-template>
				<div class="sharing-icons">
					<network class="item fb" network="facebook">
						<span class="icon" v-html="$parent.socialIcon('facebook')"></span>
					</network>
					<network class="item ln" network="linkedin">
						<span class="icon" v-html="$parent.socialIcon('linkedin')"></span>
					</network>
					<network class="item tw" network="twitter">
						<span class="icon" v-html="$parent.socialIcon('twitter')"></span>
					</network>

					<div class="item copy">
						<a
							class="icon"
							@click.prevent="$parent.cpyToClipboard"
							title="copy to clipboard"
							href="#"
							v-html="$parent.socialIcon('chain')"
						></a>
					</div>
				</div>
			</SocilaSharing>
		</div>
	</div>
</template>

<script>
// https://www.npmjs.com/package/vue-social-sharing
import SocilaSharing from 'vue-social-sharing'
import { mapGetters } from 'vuex'
import icons from '@/icons'

export default {
	name: 'share-links',
	data() {
		return {}
	},
	mounted() {},
	components: {
		SocilaSharing,
	},
	computed: {
		...mapGetters(['currentPage']),
	},
	methods: {
		fixLink() {
			const pageLink = this.currentPage.link
			const home = window.WPVUE.home.replace(/\/$/, '')

			if (pageLink.indexOf(home) === 0) {
				return pageLink
			} else {
				return home + pageLink
			}
		},
		socialIcon(media) {
			let icon = media
			const color = '#222831'
			switch (media) {
				case 'facebook':
					icon = icons.facebook(color)
					break
				case 'instagram':
					icon = icons.instagram(color)
					break
				case 'snapchat':
					icon = icons.snapchat(color)
					break
				case 'twitter':
					icon = icons.twitter(color)
					break
				case 'youtube':
					icon = icons.youtube(color)
					break
				case 'soundcloud':
					icon = icons.soundcloud(color)
					break
				case 'spotify':
					icon = icons.spotify(color)
					break
				case 'tiktok':
					icon = icons.tiktok(color)
					break
				case 'home':
					icon = icons.home(color)
					break
				case 'linkedin':
					icon = icons.linkedin(color)
					break
				case 'chain':
					icon = icons.chain(color)
					break
			}
			return icon
		},
		cpyToClipboard() {
			if (process.server) return
			/**
			 * It can copy only from input
			 * so we create dummy element, copy, and remove :)
			 */
			let input = document.createElement('input')
			input.value = this.fixLink()
			document.body.appendChild(input)
			input.select()
			document.execCommand('copy', false)
			input.remove()
			// alert("Copied the text: " + copyText.value);
		},
		printMe() {
			window.print()
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
body {
	&.theme-blue {
		.social-share-block .icon {
			path {
				fill: var(--blue);
			}
			background-color: var(--blueLight);
			&:hover {
				box-shadow: 0 0 0 2px var(--blue);
			}
		}
	}
	&.theme-green {
		.social-share-block .icon {
			path {
				fill: var(--green);
			}
			background-color: var(--greenLight);
			&:hover {
				box-shadow: 0 0 0 2px var(--green);
			}
		}
	}
	&.theme-red {
		.social-share-block .icon {
			path {
				fill: var(--red);
			}
			background-color: var(--redLight);
			&:hover {
				box-shadow: 0 0 0 2px var(--red);
			}
		}
	}
	&.theme-purple {
		.social-share-block .icon {
			path {
				fill: var(--purple);
			}
			background-color: var(--purpleLight);
			&:hover {
				box-shadow: 0 0 0 2px var(--purple);
			}
		}
	}
}

.social-share-block {
	.container {
		display: flex;
		align-items: center;
		//justify-content: center;
		@include mquery($phone) {
			flex-direction: column;
			.socialt-titler {
				margin-bottom: 20px;
			}
		}
	}
	.socialt-titler {
		margin: 0;
	}
	.sharing-icons {
		display: flex;
		.item {
			margin-left: 25px;
		}
		.icon {
			cursor: pointer;
			height: 50px;
			width: 50px;
			display: inline-block;
			background-color: var(--gray);
			border-radius: 25px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
			transition: box-shadow 0.15s ease-in-out;
			&:hover {
				box-shadow: 0 0 0 2px var(--dark);
			}
			svg {
				width: auto;
				height: 25px;
			}
		}
		@include mquery($tablet) {
			.item {
				margin-left: 20px;
			}
			.icon {
				height: 40px;
				width: 40px;
				svg {
					height: 20px;
				}
			}
		}
		@include mquery($phone) {
			.item {
				&:first-child {
					margin-left: 0px;
				}
			}
		}
	}
}
</style>
